import React from 'react';
import { Form, FormInstance, Table } from 'antd';

const EditTable: React.FC<{
  form?: FormInstance<any>;
  editableCell?: any;
  data?: any[];
  mergedColumns?: any;
  loading?: boolean;
  rowKey?: string;
}> = ({ form, editableCell, data, mergedColumns, loading, rowKey = 'id' }) => (
  <Form form={form} component={false}>
    <Table
      components={{
        body: {
          cell: editableCell,
        },
      }}
      bordered
      dataSource={data}
      columns={mergedColumns}
      rowClassName="editable-row"
      pagination={false}
      loading={loading}
      rowKey={(record) => record[rowKey]}
    />
  </Form>
);

export default EditTable;
